"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowLeft = function ArrowLeft() {
  return _react2.default.createElement(
    "g",
    { id: "arrow-left" },
    _react2.default.createElement("polygon", {
      id: "Shape",
      points: "345.784217 499.574599 404.261406 441.097411 212.954377 249.784217 404.261406 58.4771887 345.784217 0 96 249.784217"
    })
  );
};

exports.default = ArrowLeft;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/ArrowLeft.js
// module id = 2924
// module chunks = 4